import { extractInfo } from "../form";

const defaultFalse = crm => async info => {
	const { recId, updateValue } = extractInfo(info);
	!recId && updateValue(false);
};

export default defaultFalse;

